import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import configs from '../../config/config';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../assets/stylesheets/ClubSlide/LeagueGame.scss'
import {Betting, Casino, Poker } from "../Club/Main/components/Tabs";
import { useSelector, useDispatch } from "react-redux";
import { getGlobalAccountBalance, getClubProducts, getGlobalClub } from "../../store/selectors";
import { setGameCategory } from '../../store/actionCreators/gameCategories';

const gameViews = {
    poker: Poker,
    casino: Casino,
    liveCasino: Casino,
    betting: Betting,
};

const LeagueGame = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    let leagueGame = useParams().game;
    const [gameTabs, setGameTabs] = useState(['poker']);
    const prods =  useSelector(getClubProducts);
    const gbClub= useSelector(getGlobalClub);
    const clubProducts = useMemo(() => !!gbClub && prods[gbClub.clubId] ? prods[gbClub.clubId] : [], [prods, gbClub]);

    const globalBalance = useSelector(getGlobalAccountBalance);
    const View = gameViews[leagueGame];


    useEffect(() => {
        dispatch(setGameCategory(leagueGame));
        return () => {
            dispatch(setGameCategory(""));
        }
    },[leagueGame]);

    useEffect(() => {
        setGameTabs(configs.supportedTabs.filter(g => clubProducts.includes(g)));
    }, [clubProducts]);

    return (
        <div className={`leagueGameContent ${leagueGame ? leagueGame : ''} ${(leagueGame.length > 0) ? 'expanded' : ''}`}>
            <div className="header">
                <Link to={'/'} className={`closeButton`}>
                    <FontAwesomeIcon icon={faChevronLeft} color="white" className="fa chevron-left"></FontAwesomeIcon>
                </Link>
                <span className={'title'}>{t('clubLeague')}</span>
                <span className={`coinsSection`} >
                    <span className={'coins'}></span>
                    <span className={'amount'}>{globalBalance.money}</span>
                </span>
            </div>
            <div className={'gameChoice'}>
                {
                    gameTabs.map(
                        (tab, index) => 
                            <Link to={`/league/${tab}`}
                                key={index} className={`tab ${tab}Tab ${(leagueGame === tab) ? 'selected' : ''}`} >{t(`tabTitle.${tab}`)}
                            </Link>
                    )
                }
            </div>
            <div className={`gameContent`}>
                { leagueGame && <View isLeague={true} category={leagueGame}/> }
            </div>
        </div>
    );
};

export default LeagueGame;
